import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthLayoutComponent } from './_layouts/authentication/authlayout.component';
import { HomeLayoutComponent } from './_layouts/home/home-layout.component';
import { AuthGuard } from './_guards';
import { FullScreenLayout } from './_layouts/fullscrn/fullscrn-layout';
import { ManagePaymentMethodsComponent } from './manage-payment-methods/manage-payment-methods.component';

const routes: Routes = [
  // {
  //   path: '',
  //   component: HomeLayoutComponent,
  //   canActivate: [AuthGuard],
  //   loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  // },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./invoices/invoices.module').then(m => m.InvoicesPageModule)
  },
  {
    path: '',
    component: AuthLayoutComponent,
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./transactions/transactions.module').then(m => m.TransactionsPageModule)
  },
  {
    path: 'otherforms',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./other-forms/other-forms.module').then(m => m.OtherFormsModule)
  },
  {
    path: 'creditnotes',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./creditnotes/creditnotes.module').then(m => m.CreditnotesPageModule)
  },
  {
    path: 'viewstatement',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./viewstatement/viewstatement.module').then(m => m.ViewstatementPageModule)
  },
  {
    path: 'account',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./account/account.module').then(m => m.AccountsModule)
  },
  {
    path: 'payadvance',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./payadvance/payadvance.module').then(m => m.PayadvancePageModule)
  },
  {
    path: 'other-pages',
    component: FullScreenLayout,
    canActivate: [AuthGuard],
    loadChildren: () => import('./other-pages/other-pages.module').then(m => m.OtherPagesModule)
  },
  {
    path: 'app-pages',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./other-app-pages/other-app-pages.module').then(m => m.OtherAppPagesModule)
  },
  {
    path: 'landing',
    component: FullScreenLayout,
    loadChildren: () => import('./landing-pages/landing-pages.module').then(m => m.LandingPagesModule)
  },
  {
    path: 'payexapps',
    component: FullScreenLayout,
    loadChildren: () => import('./payexapps/payexapps.module').then(m => m.PayexappsModule)
  },
  {
    path: 'salesapprovalpage',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./salesapprovalpage/salesapprovalpage.module').then(m => m.SalesapprovalpageModule)
  },
  {
    path: 'manage-payment-methods',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./credit-card-management/credit-card-management.module').then(m => m.CreditCardManagementModule)
  },
  {
    path: 'manage-auto-pay',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./auto-pay-manage/auto-pay-manage.module').then(m => m.AutoPayManageModule)
  },
  {
    path: 'explore-financing',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./explore-financing/explore-financing.module').then(m => m.ExploreFinancingModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
